// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import { groupBy } from '../../utlis';
import { CURRENT_DATE } from '../../constants';
import '../../css/permission.css';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import image401 from '../../images/401.png';

const UserPermission = () => {
  const [report, setReport] = useState([]);
  const { t } = useTranslation();
  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [message, setMessage] = useState([]);
  const [executionTime, setExecutionTime] = useState(null);

  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [formReportPer,setFormReportPer]=useState([]);
  // console.log("route:",route)

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/permission%2F${route}`;
    // console.log('url:', url);
    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        const { link, inputs,permissions } = response.data;
        setLink(link);
        //console.log('link:', response.data.link);
        setInputs(inputs);
        setFormReportPer([permissions] || []);
        // console.log('inputs:', response.data.inputs);

        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load_dropdown'
          ) {
            initialState[input.name] = '%';
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        //add default values for user_id and date
        initialState['user_id'] = userId;
        //  initialState['date'] = CURRENT_DATE;
        //Set all initial input values to the state values
        setValues(initialState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();

    // setLinks(groupBy(report,'category'));
  }, [route]);

  //console.log('report:', report);
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    if (!report) return;

    const initialState = {};

    report.forEach((item) => {
      // main checkbox
      // console.log("in loop item: ",item);
      initialState[`${item.action}_${item.link_id}`] = item.is_checked;
      // console.log("in loop item: and initalState: ",initialState);
      const [edit, del] = item.has_edit_delete?.split(',') || [];

      // ✅ EDIT
      if (edit) {
        const editChecked = edit.split(':')[1] === '1';
        initialState[`edit_${item.link_id}`] = editChecked;
      }

      // ✅ DELETE
      if (del) {
        const deleteChecked = del.split(':')[1] === '1';
        initialState[`delete_${item.link_id}`] = deleteChecked;
      }
    });
    // console.log("initial state is: ",initialState);
    setCheckedItems(initialState);
  }, [report]);

  const handleCategoryChange = async (category, categoryItems, event) => {
    const isChecked = event.target.checked;

    // ✅ Update UI instantly
    setCheckedItems((prev) => {
      const newState = { ...prev };

      categoryItems.forEach((item) => {
        newState[item.link_id] = isChecked;
      });

      return newState;
    });

    // ✅ Call API for all items
    for (const item of categoryItems) {
      await handleCheckboxChange(
        item.link_id,
        item.id,
        item.action,
        { target: { checked: isChecked } } // safe event
      );
    }
  };

  const handleSubCategoryChange = async (subCategory, items, event) => {
    const isChecked = event.target.checked;

    // ✅ Update UI state first
    setCheckedItems((prev) => {
      const newState = { ...prev };

      items.forEach((item) => {
        newState[item.link_id] = isChecked;
      });

      return newState;
    });

    // ⚠️ IMPORTANT: store value BEFORE async
    // (React event gets cleared)
    for (const item of items) {
      await handleCheckboxChange(
        item.link_id,
        item.id,
        item.action,
        event // pass full event
      );
    }
  };

  const handleCheckboxChange = async (link_id, permissionID, action, event) => {
    const isChecked = event.target.checked;
    // console.log("is checked ",isChecked," link_id: ",link_id," action: ",action);
    // ✅ Determine correct key
    const key =
      action === 'edit'
        ? `edit_${link_id}`
        : action === 'delete'
          ? `delete_${link_id}`
          : `${action}_${link_id}`;

    // ✅ Update UI state
    setCheckedItems((prev) => ({
      ...prev,
      [key]: isChecked,
    }));

    let values2;

    if (route === 'student') {
      values2 = {
        link_id,
        grant_class_id: values.class_id,
        action,
        user_id: userId,
        date: CURRENT_DATE,
      };
    } else if (route === 'permissionByStudent') {
      values2 = {
        link_id,
        grant_student_id: values.student_id,
        action,
        user_id: userId,
        date: CURRENT_DATE,
      };
    } else {
      values2 = {
        grant_user_id: values.grant_user_id,
        user_id: userId,
        action,
        date: CURRENT_DATE,
        link_id,
      };
    }

    let url = '';

    if (isChecked) {
      url =
        route === 'student'
          ? `${API_URL}/${ENDPOINTS.SYS}/create/Create-Student-Permission`
          : route === 'permissionByStudent'
            ? `${API_URL}/${ENDPOINTS.SYS}/create/Create-Permission-By-Student`
            : `${API_URL}/${ENDPOINTS.SYS}/create/create-user-permission`;
    } else {
      url =
        route === 'student'
          ? `${API_URL}/${ENDPOINTS.SYS}/create/Delete-Student-Permission`
          : route === 'permissionByStudent'
            ? `${API_URL}/${ENDPOINTS.SYS}/create/Delete-By-Student-Permission`
            : `${API_URL}/${ENDPOINTS.SYS}/create/delete-user-permission`;
    }

    try {
      await axios.post(url, values2, {
        headers: { Authorization: token ? `Bearer ${token}` : '' },
      });
    } catch (err) {
      console.error('API Error:', err.message);
    }
  };
  // console.log('links:', links);

if (
      !loading &&
      formReportPer.length>0 &&
      formReportPer[0]?.can_view !== 1 &&
      formReportPer[0]?.can_view !== true
    ) {
      console.log("form report permission: ",formReportPer);
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${image401})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover",
          }}
        >
        </div>
      );
    }

  return (
    <>
      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
        setPermissions={setPermissions}
      />

      <div className="container">
        <div className="row">
          {report &&
            Object.keys(groupBy(report, 'category')).map((category) => {
              const categoryData = groupBy(report, 'category')[category];

              const categorizedData = groupBy(categoryData, 'sub_category');
              if (!Object.keys(checkedItems).length) {
                          return null; // or loading spinner
              }
              let initCatEditDel={};
                        categoryData.forEach(item=>{
                                      const [edit, del] = item.has_edit_delete?.split(',') || [];
                                      const hasEdit = edit?.split(':')[0] === '1';
                                        const hasDelete = del?.split(':')[0] === '1';
                                      if (hasEdit) {
                                        const editChecked = edit.split(':')[1] === '1';
                                        // console.log(`${item.action}_${item.link_id} has edit: ${edit}`);
                                        initCatEditDel[`edit_${item.link_id}`] = editChecked;
                                      }

                                      if (hasDelete) {
                                        const deleteChecked = del.split(':')[1] === '1';
                                        initCatEditDel[`delete_${item.link_id}`] = deleteChecked;
                                      }
                                      });
              const isCatChecked =
                          categoryData.length > 0 &&
                          categoryData.every(
                            (item,index) => 
                             checkedItems[`${item.action}_${item.link_id}`] === true || checkedItems[`${item.action}_${item.link_id}`]===1
                          ) && Object.values(initCatEditDel).every(
                            (val,index) => val === true
                          );
              return (
                <div key={category} className="col-4">
                  <div className="category-container">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={
                        categoryData.length > 0 && isCatChecked
                        
                        // categoryData.every(
                        //   (item) => checkedItems[item.link_id] === true
                        // )
                      }
                      onChange={(e) =>
                        handleCategoryChange(category, categoryData, e)
                      }
                      ref={(el) => {
                        if (el) {
                          const allChecked = categoryData.every(
                            (item) => checkedItems[item.link_id] === true
                          );

                          const someChecked = categoryData.some(
                            (item) => checkedItems[item.link_id]
                          );

                          el.indeterminate = !allChecked && someChecked;
                        }
                      }}
                    />
                    <label className="form-check-label">
                      &nbsp; {t(category)}
                    </label>

                    <ul className="nested-list">
                      {Object.keys(categorizedData).map((subCategory) => {
                        const items = categorizedData[subCategory];
                        let initSubEditDel={};
                        items.forEach(item=>{
                                      const [edit, del] = item.has_edit_delete?.split(',') || [];
                                      const hasEdit = edit?.split(':')[0] === '1';
                                        const hasDelete = del?.split(':')[0] === '1';
                                      if (hasEdit) {
                                        const editChecked = edit.split(':')[1] === '1';
                                        // console.log(`${item.action}_${item.link_id} has edit: ${edit}`);
                                        initSubEditDel[`edit_${item.link_id}`] = editChecked;
                                      }

                                      if (hasDelete) {
                                        const deleteChecked = del.split(':')[1] === '1';
                                        initSubEditDel[`delete_${item.link_id}`] = deleteChecked;
                                      }
                                      });

                        

                        const validSubCategory =
                          subCategory && subCategory.trim() !== ''
                            ? subCategory
                            : category;
                        if (!Object.keys(checkedItems).length) {
                          return null; // or loading spinner
                        }
                        // Subcategory checked if ALL children are checked
                        const isSubChecked =
                          items.length > 0 &&
                          items.every(
                            (item,index) => 
                             checkedItems[`${item.action}_${item.link_id}`] === true || checkedItems[`${item.action}_${item.link_id}`]===1
                          ) && Object.values(initSubEditDel).every(
                            (val,index) => val === true  
                          );
                          // console.log("checked items: ",checkedItems);
                          // console.log("sub category: ",subCategory);
                          // console.log("items: ",items);
                          // console.log("valid subcategory: ",validSubCategory);
                          // console.log("is subchecked: ",isSubChecked);
                        return (
                          <li key={validSubCategory}>
                            {/* SUBCATEGORY CHECKBOX */}
                            <input
                              type="checkbox"
                              checked={
                                items.length > 0 && isSubChecked
                                // items.every(
                                //   (item) => checkedItems[item.link_id] === true
                                // )
                              }
                              onChange={(e) =>
                                handleSubCategoryChange(subCategory, items, e)
                              }
                              ref={(el) => {
                                if (el) {
                                  const allChecked = items.every(
                                    (item) =>
                                      checkedItems[item.link_id] === true
                                  );

                                  const someChecked = items.some(
                                    (item) => checkedItems[item.link_id]
                                  );

                                  el.indeterminate = !allChecked && someChecked;
                                }
                              }}
                            />

                            <label>&nbsp; {t(validSubCategory)}</label>

                            <ul>
                              {items.map((item) => {
                                const [edit, del] =
                                  item.has_edit_delete?.split(',') || [];

                                const hasEdit = edit?.split(':')[0] === '1';
                                const hasDelete = del?.split(':')[0] === '1';
                                // if (item.link.includes('Teacher Charges')) {
                                //   console.log(`item ${item.link}:`, item);
                                //   console.log('ed-del:', edit, del);
                                //   console.log('hed-hdel:', hasEdit, hasDelete);
                                // }
                                return (
                                  <li
                                    key={`${item.action}-${item.link_id}`}
                                    style={{
                                      listStyle: 'none',
                                      marginLeft: 0,
                                      paddingLeft: 0,
                                    }}
                                  >
                                    {' '}
                                    {/* MAIN CHECKBOX */}
                                    <input
                                      type="checkbox"
                                      className={`form-check-input ${category.replace(
                                        /\s/g,
                                        ''
                                      )}`}
                                      checked={
                                        checkedItems[`${item.action}_${item.link_id}`] || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          item.link_id,
                                          item.id,
                                          item.action,
                                          e
                                        )
                                      }
                                    />
                                    <label>&nbsp; {t(item.link)}</label>
                                    {/* EDIT / DELETE */}
                                    {(hasEdit || hasDelete) && (
                                      <ul>
                                        {hasEdit && (
                                          <li
                                            style={{
                                              listStyle: 'none',
                                              marginLeft: 0,
                                              paddingLeft: 0,
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                checkedItems[
                                                  `edit_${item.link_id}`
                                                ] || false
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  item.link_id,
                                                  item.id,
                                                  'edit',
                                                  e
                                                )
                                              }
                                            />
                                            &nbsp; Edit {t(item.link)}
                                          </li>
                                        )}

                                        {hasDelete && (
                                          <li
                                            style={{
                                              listStyle: 'none',
                                              marginLeft: 0,
                                              paddingLeft: 0,
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                checkedItems[
                                                  `delete_${item.link_id}`
                                                ] || false
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  item.link_id,
                                                  item.id,
                                                  'delete',
                                                  e
                                                )
                                              }
                                            />
                                            &nbsp; Delete {t(item.link)}
                                          </li>
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default UserPermission;
